<template>
    <div class="shadow-off pt-2 pb-0 pl-0 pr-0">
        <div>
            <v-card class="shadow-off">
                <div class="d-flex align-center justify-end mb-4 mt-4">
                    <v-btn
                        v-if="hasActiveTableFilter"
                        text
                        class="mr-2 data-table-action__clear-filter-btn"
                        @click="clearTableFilter"
                        data-testid="step-middleware-config-v2__clear-filter-btn"
                    >
                        <span>Clear Filter</span>
                    </v-btn>
                    <v-btn data-testid="step-middleware-config-v2__add-btn" color="primary" @click="$emit('addMiddlewarebox')">
                        <v-icon data-testid="step-middleware-config-v2__add-icon" class="mr-1">mdi-plus</v-icon>
                        <span>Mapping Master</span>
                    </v-btn>
                </div>
                <v-card-text data-testid="step-middleware-config-v2__table" class="pa-0" v-if="formatedDataMiddeleware.length > 0">
                    <lb-datatableaction ref="dataTableAction" :headers="HEADERS" :tabledata="mappedTableData" :bulkActions="false" :selectfilter="{}" :page_details="{}" @filter-item="filterData" @clear-item="clearFilter">
                        <template v-slot:tbody>
                            <tr
                                data-testid="step-middleware-config-v2__row"
                                v-for="item in filteredTableData"
                                :key="item._id"
                                class="cursor-pointer"
                                :class="{ 'low-opacity': item.status === false }"
                            >
                                <td class="px-3 text-center body-2" data-testid="step-middleware-config-v2__col-indexno">{{ item.indexno }}</td>
                                <td class="px-3 body-2" data-testid="step-middleware-config-v2__col-dataset">{{ getDatasetCombinationName(item) }}</td>
                                <td class="px-3 body-2" data-testid="step-middleware-config-v2__col-middlewarename">
                                    <div
                                        data-testid="step-middleware-config-v2__file-link"
                                        @click="$nova.downloadFile(item.middlewarefile)"
                                        class="cursor-pointer blue--text text--darken-2 caption"
                                    >
                                        {{ item.middlewarename }}
                                    </div>
                                </td>
                                <td class="px-3 body-2" data-testid="step-middleware-config-v2__col-basefile">{{ getTableName(item.basefile) }}</td>
                                <td class="px-3 single-line border-on action-data" data-testid="step-middleware-config-v2__col-action">
                                        <div class="d-flex align-center gap-1">
                                            <v-tooltip bottom content-class="tooltip-bottom">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        data-testid="step-middleware-config-v2__edit-btn"
                                                        icon small v-bind="attrs" v-on="on"
                                                        @click.stop="$emit('editmiddlewarebox', item)"
                                                    >
                                                        <v-icon small>mdi-pencil</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Edit</span>
                                            </v-tooltip>
                                            <v-tooltip bottom content-class="tooltip-bottom">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                        data-testid="step-middleware-config-v2__delete-btn"
                                                        icon small v-bind="attrs" v-on="on"
                                                        @click.stop="promptDelete(item)"
                                                    >
                                                        <img src="/img/icons/tm-icons/Trash.svg" alt="Delete" data-testid="step-middleware-config-v2__delete-icon" />
                                                    </v-btn>
                                                </template>
                                                <span>Delete</span>
                                            </v-tooltip>
                                            <v-divider vertical class="mx-1" />
                                            <v-switch
                                                data-testid="step-middleware-config-v2__status-toggle"
                                                :input-value="item.status"
                                                :false-value="false"
                                                :true-value="true"
                                                :label="item.status ? 'Enabled' : 'Disabled'"
                                                @change="$emit('changeMid', item._id, $event)"
                                                inset
                                                dense
                                                color="primary"
                                                class="mt-0 pt-0"
                                                hide-details
                                            />
                                        </div>
                                </td>
                            </tr>
                        </template>
                    </lb-datatableaction>
                </v-card-text>
                <div data-testid="step-middleware-config-v2__empty-state" v-else class="text-center grey--text title pa-6">No data available</div>
            </v-card>
        </div>

        <!-- Delete Confirmation Dialog -->
        <confirm-delete-dialog
            v-model="showDeleteDialog"
            message="Are you sure you want to delete this middleware?"
            dat-testid="step-middleware-config-v2"
            @confirm="confirmDelete"
        />
    </div>
</template>

<script>
import ConfirmDeleteDialog from './ConfirmDeleteDialog.vue';

export default {
    name: 'StepMiddlewareConfigV2',

    components: { ConfirmDeleteDialog },

    props: {
        formatedDataMiddeleware: {
            type: Array,
            default: () => [],
        },
        setupList: {
            type: Object,
            default: () => ({}),
        },
        fileConfigInfo: {
            type: Object,
            default: () => ({}),
        },
    },

    computed: {
        HEADERS() {
            return [
                { text: 'S No.',               value: 'indexno',            visible: true, sortable: false, filterable: false },
                { text: 'Dataset Combination',  value: 'datasetcombination', visible: true, sortable: false, filterable: true  },
                { text: 'Middleware Name',       value: 'middlewarename',     visible: true, sortable: false, filterable: true  },
                { text: 'Base File',            value: 'basefile',           visible: true, sortable: false, filterable: true  },
                { text: 'Action',               value: 'action',             visible: true, sortable: false, filterable: false },
            ];
        },

        // Maps raw IDs to display names so column filter dropdowns show readable values.
        mappedTableData() {
            return this.formatedDataMiddeleware.map(item => ({
                ...item,
                datasetcombination: this.getDatasetCombinationName(item),
                basefile: this.getTableName(item.basefile),
            }));
        },

        filteredTableData() {
            const filters = this.tableFilters;
            if (!filters || Object.keys(filters).length === 0) return this.formatedDataMiddeleware;
            return this.formatedDataMiddeleware.filter((rawItem, idx) => {
                const displayItem = this.mappedTableData[idx];
                return Object.entries(filters).every(([key, values]) => {
                    if (!values || values.length === 0) return true;
                    const cellValue = String(displayItem[key] !== undefined && displayItem[key] !== null ? displayItem[key] : '');
                    return values.some(v => String(v) === cellValue);
                });
            });
        },

        hasActiveTableFilter() {
            return Object.values(this.tableFilters || {}).some(v => Array.isArray(v) ? v.length > 0 : !!v);
        },
    },

    data() {
        return {
            showDeleteDialog: false,
            deleteTarget: null,
            tableFilters: {},
        };
    },

    beforeDestroy() {
        this.showDeleteDialog = false;
        this.deleteTarget = null;
        this.tableFilters = {};
    },

    methods: {
        promptDelete(item) {
            this.deleteTarget = item;
            this.showDeleteDialog = true;
        },
        confirmDelete() {
            if (this.deleteTarget !== null) {
                this.$emit('deletemiddlewarebox', this.deleteTarget);
                this.deleteTarget = null;
                this.showDeleteDialog = false;
            }
        },
        filterData(filters) {
            this.tableFilters = filters || {};
        },
        clearFilter() {
            this.tableFilters = {};
        },
        clearTableFilter() {
            if (this.$refs.dataTableAction) {
                this.$refs.dataTableAction.clearfilter();
            } else {
                this.tableFilters = {};
            }
        },
        getTableName(id) {
            const file = (this.setupList?.file || []).find(f => f._id === id);
            return file ? file.name : id || '—';
        },

        getDatasetCombinationName(item) {
            const { fileConfig1, fileConfig2 } = item;
            if (!fileConfig1 && !fileConfig2) return '—';
            const resolveName = (configId) => {
                if (!configId) return null;
                const cfg = this.fileConfigInfo[configId];
                if (cfg) {
                    const file = (this.setupList?.file || []).find(f => f._id === cfg.file || f._id === configId);
                    return file ? file.name : (cfg.name || configId);
                }
                // fallback: treat configId as a file _id directly
                const file = (this.setupList?.file || []).find(f => f._id === configId);
                return file ? file.name : configId;
            };
            const name1 = resolveName(fileConfig1);
            const name2 = resolveName(fileConfig2);
            if (name1 && name2) return `${name1} vs ${name2}`;
            return name1 || name2 || '—';
        },
    },
};
</script>
